import { ApiEndpointSpecification } from './types';
import { HttpMethod } from '../http-request';
import * as Helpers from '../api-request-helpers';
import * as Types from '../types';
import { DEVICE_DETAILS } from './url-constants';

type DeviceDetailsEndpointSpecification = ApiEndpointSpecification;
export const DeviceDetailsEndpointSpecification: DeviceDetailsEndpointSpecification = {
    url: DEVICE_DETAILS,
    method: HttpMethod.GET,
    requestParamsSchemaName: 'DeviceDetailsRequestParams',
    requestBodySchemaName: 'DeviceDetailsRequestBody',
    okResponseSchemaName: 'DeviceDetailsOkResponse',
    notOkResponseSchemaName: 'GenericNotOkResponse',
    authenticated: true,
    version: 3,
};

export const invokeDeviceDetails = Helpers.makeApiRequestFn<
    Types.DeviceDetailsRequestParams,
    Types.DeviceDetailsRequestBody,
    Types.DeviceDetailsOkResponse
>(DeviceDetailsEndpointSpecification);
